<ion-content (touchstart)="onTouchStart($event)"
(touchmove)="onTouchMove($event)"
(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/logo.svg" alt="Logo">
			</header>

			<div class="main">
				<div class="mr-potty">
					<img src="assets/images/describe-secretion/mr.potty.svg" alt="Mr Potty">
				</div>

				<div class="main-content">
					<h2 class="title">What's the business, #1 or #2?</h2>

					<app-progress-bar [activeStep]="4"></app-progress-bar>

					<div class="pee-poo-wrapper">

						<div class="pee-poo" [ngClass]="selectedHero ? 'horizontal' : ''">

							<button class="pee-poo__button" [ngClass]="selectedHero === 'pee' ? 'selected' : ''"
								(click)="setSelectedHero('pee')">
								<img src="assets/images/describe-secretion/mrs.pee.svg" alt="Mrs Pee">
							</button>

							<button class="pee-poo__button" [ngClass]="selectedHero === 'poo' ? 'selected' : ''"
								(click)="setSelectedHero('poo')">
								<img src="assets/images/describe-secretion/mr.poo.svg" alt="Mr Poo">
							</button>

						</div>

						<div class="cards" *ngIf="selectedHero" #cardsContainer>
							<div class="card" @cardTransition
								*ngFor="let card of selectedHero  === 'pee' ? peeCards : pooCards"
								(click)="setSelectedImagePath(card.imgPath)"
								[ngClass]="selectedImagePath === card.imgPath ? 'selected' : ''">
								<div class="card__content">
									<img class="img" [ngClass]="selectedHero"
										[ngStyle]="{ marginBottom: isCardsTextVisible ? '2vh' : '0' }"
										[src]="card.imgPath" alt="Card Image">
									<p class="text" *ngIf="isCardsTextVisible">{{ card.imgText }}</p>
								</div>
							</div>
						</div>

					</div>
				</div>

			<app-navigation-buttons 
				(click)="saveSecretionMetadata($event)"
				[isSkipButtonHidden]="true"
				[twoButtonsShowing]="true"
				[nextButtonText]="nextButtonText"
				[isSkipDisplayed]="nextButtonText === 'skip'">
			</app-navigation-buttons>

			</div>

		</div>
	</div>
</ion-content>
